// extracted by css-extract-rspack-plugin
export default {"segmentsLink":"Rq5lR","active":"sT_Xd","segmentsIcon":"rMgFt"};